import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getCurrentTimestamp } from '../shared/helpers/my.helper';
import { DashboardService } from '../shared/services/dashboard.service';

interface FlowTrackingRow {
  action: string;
  device_id: string;
  driver_name: string;
  truck_number: string;
  timestamp: string;
  location?: string;
  receive_volume?: number | string | null;
}

interface FlowTrackingResponse {
  status: number;
  message: string;
  data?: FlowTrackingRow[];
}

@Component({
  selector: 'app-flow-tracking',
  templateUrl: './flow-tracking.component.html',
  styleUrls: ['./flow-tracking.component.scss']
})
export class FlowTrackingComponent implements OnInit {
  public readonly status_message = 'No flow readings to display.';
  public tracking_rows: FlowTrackingRow[] = [];
  public date_range = {
    start: getCurrentTimestamp(true),
    end: getCurrentTimestamp(true)
  };

  private readonly toastOptions = { timeOut: 5000, closeButton: true };

  constructor(
    private toastr: ToastrService,
    private dashboardService: DashboardService
  ) {}

  ngOnInit(): void {
    this.getTabularData();
  }

  onDateRangeChange(selected: { start: string; end: string }): void {
    this.date_range = selected;
    this.getTabularData();
  }

  onUpdateTabularData(response: FlowTrackingResponse): void {
    if (response.status === 409) {
      this.toastr.warning(response.message, '', this.toastOptions);
    } else if (response.status === 200) {
      this.toastr.success(response.message, '', this.toastOptions);
    }

    this.getTabularData();
  }

  getTabularData(): void {
    this.dashboardService
      .httpPost(this.getBody('getFlowTrackingData', {
        range: { from: this.date_range.start, to: this.date_range.end }
      }))
      .subscribe((response: any) => {
        this.tracking_rows = response.data || [];
      });
  }

  stopFlowTracking(device_id: string): void {
    this.dashboardService
      .httpPost(this.getBody('stopFlowTracking', { device_id }))
      .subscribe((response: any) => {
        this.onUpdateTabularData(response);
      });
  }

  private getBody(
    action: string,
    params: { range?: { from: string; to: string }; device_id?: string } = {}
  ) {
    return {
      action,
      user_id: [localStorage.getItem('user')],
      ...params
    };
  }
}
